import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './pages/root';
import store from './store';
import { Provider } from 'react-redux';
import registerServiceWorker from './registerServiceWorker';

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <Root />
    </Provider>,
    document.getElementById('root')
  );
};
render();
// if (process.env.NODE_ENV === 'development') {
//   if (module.hot) {
//     module.hot.accept(() => {
//       render();
//     });
//   }
// }

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js